import { useEffect } from "react"

const WHATSAPP_URL = `https://chat.whatsapp.com/CZ31XBYrrBi2sZE1WVln0T`

export function LinkGrupoWhatsapp() {
    useEffect(() => {
        window.location.href = WHATSAPP_URL
    }, [])
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100dvh",
                background: "linear-gradient(135deg, #e9fbe9 0%, #d0f0d0 100%)",
                gap: "16px",
            }}
        >
            <div style={{ fontSize: "64px" }}>💬</div>
            <h2 style={{ color: "#128C7E", fontWeight: "bold", margin: 0, textAlign: "center" }}>
                WhatsApp Bloqueado Nunca Mais
            </h2>
            <p
                style={{
                    color: "#128C7E",
                    fontWeight: "600",
                    margin: 0,
                    fontSize: "13px",
                    letterSpacing: "1px",
                }}
            >
                API OFICIAL
            </p>
            <p style={{ color: "#555", margin: 0, marginTop: "4px" }}>
                Clique abaixo para entrar no grupo
            </p>
            <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    backgroundColor: "#25D366",
                    padding: "12px 32px",
                    fontSize: "16px",
                    borderRadius: "30px",
                    marginTop: "8px",
                    color: "#fff",
                    textDecoration: "none",
                    display: "inline-block",
                }}
            >
                Entrar no grupo
            </a>
        </div>
    )
}
